export class File {
    constructor(
        public createdDate: string = "1900-01-01",
        public createdBy: string = "",
        public id: string = "",
        public name: string = "",
        public contentType: string = ""
    ){}
}